import { useRef, useState } from "react"
import { Avatar, Tooltip } from "@callcenter/design-system"
import { useUnit } from "effector-react"
import { t } from "i18next"
import type { UiState, Statuses } from "@callcenter/shared-types"
import { useCustomOnClickOutside } from "@callcenter/hooks"
import { buildUserInitials } from "@callcenter/helpers"
import { $userService } from "@callcenter/effector-services"

import { UserProfilePopup } from "../user-profile-popup"
import { defineUiStatusColor } from "../../shared/helpers"

import styles from "./user-profile.module.pcss"

type Props = {
  status: Statuses
  uiState: UiState
  popupTopPosition?: string
}

export const UserProfile = ({ status, uiState, popupTopPosition }: Props) => {
  const userProfileRef = useRef<HTMLButtonElement>(null)
  const userInfo = useUnit($userService.$userSettings)

  const [isOpen, setOpen] = useState(false)

  useCustomOnClickOutside(userProfileRef, () => setOpen(false))

  return (
    <div className={styles.container} onClick={() => setOpen(!isOpen)}>
      <Tooltip
        isVisibleDisabled={userProfileRef.current?.classList.contains("active")}
        title={t("userProfile_MenuBar_tooltip_userProfileMainMenuBarTooltip")}
        position="underCenter"
        alternativePosition="underLeft"
        isHighestLayer
      >
        <button className={styles.userProfile} data-click-target-exclude="true" ref={userProfileRef}>
          <Avatar
            header={{ status: String(status), backgroundColor: defineUiStatusColor(uiState, status) }}
            initials={buildUserInitials(userInfo.name)}
          />
        </button>
      </Tooltip>

      <UserProfilePopup userProfilePicRef={userProfileRef} topPosition={popupTopPosition} />
    </div>
  )
}
